import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useBooleanState } from 'shared/hooks/state/boolean';
import AddIcon from '@mui/icons-material/Add';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { IconTab } from 'shared/components/icon/icon-tab';
import { useGetStorageOrFetchIcon } from 'shared/api/hooks';
import { Control } from 'shared/components/fields/control';
import { noop } from 'ts-essentials';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { IconForWebElement } from 'shared/components/panels/custom-controls/custom-controls-card/components/icon';
import ClearIcon from '@mui/icons-material/Clear';
export const IconsLibrary = memo(function IconSelection(props) {
    const { onChange, icons, value, customTab } = props;
    const [responseIcon, run, , ,] = useGetStorageOrFetchIcon('get_icons_user');
    const [selectedIconId, setSelectedIconId] = useState(value ?? null);
    useEffect(() => {
        setSelectedIconId(value ?? null);
    }, [value]);
    const [dialog_open, closeDialog, openDialog] = useBooleanState(false);
    const idsIconUser = useAppSelector((state) => state.user_icons.idsIconUser);
    const web_element_icon_icon_value = useMemo(() => {
        if (typeof selectedIconId === 'string' || typeof selectedIconId === 'number') {
            if (typeof value === 'number') {
                return (icons.find((settings_icon) => settings_icon.id === selectedIconId) ?? null);
            }
            else {
                return (idsIconUser.find((settings_icon) => settings_icon === selectedIconId) ?? null);
            }
        }
        return null;
    }, [selectedIconId]);
    const current_icon = useMemo(() => {
        if (typeof selectedIconId === 'string' || typeof selectedIconId === 'number') {
            if (typeof selectedIconId === 'number') {
                return icons.find(({ id }) => id === selectedIconId) ?? null;
            }
            else {
                return responseIcon.find(({ id }) => id === selectedIconId) ?? null;
            }
        }
        return null;
    }, [value, selectedIconId, responseIcon]);
    const onAutocompleteChange = useCallback((id) => {
        closeDialog();
        setSelectedIconId(id);
        onChange(id);
    }, [onChange]);
    useEffect(() => {
        if (selectedIconId && typeof selectedIconId === 'string') {
            run([selectedIconId]);
        }
    }, [selectedIconId]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", justifyContent: "flex-end", children: [_jsx(Control, { label: "\u0418\u043A\u043E\u043D\u043A\u0430", onChange: noop, validation_warnings_result: null, validation_result: null, value: null, field: () => (_jsx(OutlinedInput, { disabled: true, margin: "dense", startAdornment: _jsx(InputAdornment, { position: "start", children: web_element_icon_icon_value && (_jsx(IconForWebElement, { icon: web_element_icon_icon_value, fontSize: "1em", onClick: openDialog })) }), value: current_icon != null ? current_icon.title : 'Не выбрана', endAdornment: _jsxs(InputAdornment, { position: "end", children: [_jsx(IconButton, { edge: "end", onClick: openDialog, children: _jsx(AddIcon, {}) }), current_icon != null && (_jsx(IconButton, { onClick: () => onAutocompleteChange(null), children: _jsx(ClearIcon, {}) }))] }) })) }), _jsx(MessageBox, { open: dialog_open, onClose: closeDialog, children: _jsx(IconTab, { title: "\u0413\u0430\u043B\u0435\u0440\u0435\u044F \u0438\u043A\u043E\u043D\u043E\u043A", onChangeIcon: onAutocompleteChange, customTab: customTab }) })] }));
});
